import React, { useState, useRef, useEffect } from "react";
import course_bg from "../../assets/img/Course/Our Course/course-bg.jpeg";
import "../../assets/css/Ourcourse.css";

import indusrty_automation1 from "../../assets/img/Course/Our Course/industrial-automation 1.jpg";
import indusrty_automation2 from "../../assets/img/Course/Our Course/industrial-automation 2.jpg";
import indusrty_automation3 from "../../assets/img/Course/Our Course/industrial-automation 3.jpg";
import indusrty_automation4 from "../../assets/img/Course/Our Course/industrial-automation 4.jpg";

import expert_icon from "../../assets/icons/expert-instructer.png";
import hands_on_lab from "../../assets/icons/hands-on-lab.png";
import industry_certificate from "../../assets/icons/industry-certificate.png";
import flexiable_learn from "../../assets/icons/flexiable-learning.png";
import placement_icon from "../../assets/icons/palcement-icon.png";
import industry_icon from "../../assets/icons/industry-icon.png";

import clock_icon from "../../assets/icons/clock-icon.png";
import { FiChevronRight, FiChevronLeft } from "react-icons/fi";
import { Helmet } from "react-helmet";
import data from "../ApiUrl/meta_api.js";

//Embadded system
import es_1 from "../../assets/img/Course/Our Course/embadded 1.jpg";
import es_2 from "../../assets/img/Course/Our Course/embadded 2.jpg";
import es_3 from "../../assets/img/Course/Our Course/embadded 3.jpg";

//IT & Software
import it_1 from "../../assets/img/Course/Our Course/it-1.jpg";
import it_2 from "../../assets/img/Course/Our Course/it-2.jpg";
import it_3 from "../../assets/img/Course/Our Course/it-3.jpg";
import it_4 from "../../assets/img/Course/Our Course/it-4.jpg";
import it_5 from "../../assets/img/Course/Our Course/it-5.jpg";
import it_6 from "../../assets/img/Course/Our Course/it-6.jpg";
import it_7 from "../../assets/img/Course/Our Course/it-7.jpg";
import it_8 from "../../assets/img/Course/Our Course/it-8.jpg";
import it_9 from "../../assets/img/Course/Our Course/it-9.jpg";
import it_10 from "../../assets/img/Course/Our Course/it-10.jpg";

//Digital Marketing
import dm_1 from "../../assets/img/Course/Our Course/dm-1.jpg";
import dm_2 from "../../assets/img/Course/Our Course/dm-2.jpg";
import dm_3 from "../../assets/img/Course/Our Course/dm-3.jpg";

/* ══════════════════════════════════════════════════
   DATA
══════════════════════════════════════════════════ */

const whyCards = [
  {
    icon: expert_icon,
    title: "Expert Instructors",
    desc: "Learn from certified automation engineers with 10+ years of hands-on industry experience in PLC, SCADA, robotics, and process control systems.",
  },
  {
    icon: hands_on_lab,
    title: "Hands-On Lab Training",
    desc: "Practice on genuine industrial hardware Siemens, Allen-Bradley, Mitsubishi, Schneider not just software simulators.",
  },
  {
    icon: industry_certificate,
    title: "Industry-Recognised Certification",
    desc: "Earn certifications valued by manufacturing, energy, and logistics companies across India and globally.",
  },
  {
    icon: flexiable_learn,
    title: "Flexible Learning Modes",
    desc: "Choose in-person classroom, live online, or hybrid training structured to fit your schedule and learning pace.",
  },
  {
    icon: placement_icon,
    title: "Placement Assistance",
    desc: "Dedicated career support resume building, mock interviews, and direct referrals to our verified hiring partner network.",
  },
  {
    icon: industry_icon,
    title: "Industry 4.0 Curriculum",
    desc: "Our syllabus is continuously updated to cover IIoT, Industry 4.0, and the latest automation technologies and standards.",
  },
];

const faqItems = [
  {
    q: "What is industrial automation training and why is it important?",
    a: "Industrial automation training equips engineers and technicians with skills to design, program, operate, and maintain automated systems using PLCs, SCADA, HMI, robotics, and industrial networks. With manufacturing and process industries worldwide accelerating automation adoption, certified professionals are in consistently high demand.",
  },
  {
    q: "Who should enrol in these automation courses?",
    a: "These programs are ideal for B.E./B.Tech graduates in Electrical, Electronics, Mechanical, or Instrumentation, diploma holders, ITI students, and working professionals seeking skill upgrades or a domain switch into the automation industry.",
  },
  {
    q: "What certifications will I receive upon completion?",
    a: "You receive an industry-recognised certification from Skimitar Hindusthan, aligned with real-world competencies tested by employers in automation, manufacturing, and energy sectors across India.",
  },
  {
    q: "Are courses available in online mode?",
    a: "Yes. We offer in-person classroom training at our Salem and Erode centres, live online sessions, and hybrid modes so you can learn without disrupting current studies or employment.",
  },
  {
    q: "What career roles can I target after this training?",
    a: "Graduates typically secure roles such as PLC Engineer, SCADA Operator, Automation Technician, Control Systems Engineer, DCS Engineer, Maintenance Engineer, and Industrial IoT Developer across manufacturing, energy, automotive, and logistics sectors.",
  },
  {
    q: "Is placement support included?",
    a: "Yes. Every enrolled student receives dedicated placement support including professional resume building, mock technical and HR interview sessions, LinkedIn profile optimisation, and direct referrals to our verified hiring partner network.",
  },
];

const partnerLogos = [
  {
    name: "Siemens",
    img: require("../../assets/img/Course/Our Course/logo/logo-1.jpg"),
  },
  {
    name: "AMS Brand",
    img: require("../../assets/img/Course/Our Course/logo/logo-2.jpg"),
  },
  {
    name: "ATPR",
    img: require("../../assets/img/Course/Our Course/logo/logo-3.jpg"),
  },
  {
    name: "HCL",
    img: require("../../assets/img/Course/Our Course/logo/logo-4.jpg"),
  },
  {
    name: "Tekseii Solutions",
    img: require("../../assets/img/Course/Our Course/logo/logo-5.jpg"),
  },
  {
    name: "Infosys",
    img: require("../../assets/img/Course/Our Course/logo/logo-6.jpg"),
  },
  {
    name: "FarmXT",
    img: require("../../assets/img/Course/Our Course/logo/logo-7.jpg"),
  },
  {
    name: "Sasi Nutraceuticals",
    img: require("../../assets/img/Course/Our Course/logo/logo-8.jpg"),
  },
];

const journeySteps = [
  {
    label: "Assess Your Training Goals",
    desc: "Identify your current skill level and the automation domain PLC, SCADA, robotics, or networking that aligns with your career target.",
  },
  {
    label: "Choose the Right Program",
    desc: "Select from beginner, intermediate, or advanced certification programs, each designed to build progressively on the previous level.",
  },
  {
    label: "Gain Hands-On Experience",
    desc: "Work on real automation equipment and live industry projects during training, building a tangible portfolio before you start applying.",
  },
  {
    label: "Get Certified & Get Hired",
    desc: "Complete your certification and access full placement support resume crafting, mock interviews, and recruiter referrals until you land the right role.",
  },
];

const topCategories = [
  {
    id: "industrial-automation",
    plainWord: "Our Industrial ",
    subword: "Automation Courses",
    desc: "Our Industrial Automation programs equip engineers and freshers with hands-on PLC, SCADA, HMI and IIoT skills building real careers in manufacturing, energy, and process industries across India.",
    courses: [
      {
        id: "ia-1",
        title: "Master PLC Programming & Industrial Automation",
        subtitle:
          "Real Siemens PLC hardware, Ladder Logic programming, sensor interfacing and panel wiring all in 30 hands-on days.",
        level: "Beginner",
        duration: "1 Month",
        imgSrc: indusrty_automation1,
        alt: "PLC Industrial Automation Quick Start Course Skimitar Hindusthan",
        smallcard: [
          { card1: "PLC Basic" },
          { card2: "Ladder logic" },
          { card3: "Siemens" },
          { card4: "Sensors" },
        ],
      },
      {
        id: "ia-2",
        title: "Certified PLC & SCADA Engineer",
        subtitle:
          "ZelioSoft 2 + Allen Bradley + HMI industry-recognised certification with live SCADA dashboard project.",
        level: "Advanced",
        duration: "2 Months",
        imgSrc: indusrty_automation2,
        alt: "Industrial Automation Essentials Ladder Logic HMI Course Skimitar Hindusthan",
        smallcard: [
          { card1: "ZelioSoft 2" },
          { card2: "Allen Bradley" },
          { card3: "SCADA" },
          { card4: "HMI" },
        ],
      },
      {
        id: "ia-3",
        title: "Industrial Automation Engineer",
        subtitle:
          "Master 4 PLC platforms Siemens, Allen Bradley, Mitsubishi, Schneider plus SCADA, HMI and VFD. Commission real machines.",
        level: "Professional",
        duration: "3 Months",
        imgSrc: indusrty_automation3,
        alt: "Certified Industrial Automation Professional Course PLC SCADA Skimitar Hindusthan",
        smallcard: [
          { card1: "4 PLC Brands" },
          { card2: "SCADA" },
          { card3: "VFD" },
          { card4: "Panels" },
        ],
      },
      {
        id: "ia-5",
        title: "Industrial Automation Mastery",
        subtitle:
          "8 PLC brands, VFD, SCADA, Industry 4.0 and IIoT cloud integration. The most comprehensive automation program in Tamil Nadu.",
        level: "Expert",
        duration: "6 Months",
        imgSrc: indusrty_automation4,
        alt: "Professional Industrial Automation Engineer IIoT Industry 4.0 Skimitar Hindusthan",
        smallcard: [
          { card1: "8 PLC Brands" },
          { card2: "Industry 4.0" },
          { card3: "IIOT" },
          { card4: "OEE" },
        ],
      },
    ],
  },
  {
    id: "embedded-iot",
    plainWord: "Our Embedded Systems & ",
    subword: "IIoT Courses",
    desc: "Master embedded hardware design, firmware programming, IoT connectivity and cloud integration. Our Embedded Systems courses prepare you for roles in automotive, consumer electronics and smart manufacturing sectors.",
    courses: [
      {
        id: "es-1",
        title: "Embedded Systems Kickstart",
        subtitle:
          "Arduino, ESP32, sensor interfacing, I2C, SPI and GPIO in 30 days. Build real circuits from Day 1 on actual hardware.",
        level: "Beginner",
        duration: "1 Months",
        imgSrc: es_1,
        alt: "Embedded C Microcontroller ARM Cortex Course Skimitar Hindusthan",
        smallcard: [
          { card1: "Arduino" },
          { card2: "ESP32" },
          { card3: "Sensors" },
          { card4: "I2C/SPI" },
        ],
      },
      {
        id: "es-2",
        title: "Embedded Systems Engineer",
        subtitle:
          "ARM Cortex, FreeRTOS, IIoT protocols, BLE, MQTT and Edge AI. Write production firmware for real embedded products.",
        level: "Advanced",
        duration: "2 Months",
        imgSrc: es_2,
        alt: "IoT Product Development ESP32 AWS MQTT Course Skimitar Hindusthan",
        smallcard: [
          { card1: "ARM Cortex" },
          { card2: "FreeRTOS" },
          { card3: "MQTT" },
          { card4: "Edge AI" },
        ],
      },
      {
        id: "es-3",
        title: "Embedded & IIoT Mastery",
        subtitle:
          "ARM, RTOS, Automotive AUTOSAR, Edge AI and Smart Factory Architecture become a complete embedded product engineer.",
        level: "Expert",
        duration: "6 Months",
        imgSrc: es_3,
        alt: "Industrial IoT Edge Computing OPC-UA Predictive Maintenance Skimitar Hindusthan",
        smallcard: [
          { card1: "AUTOSAR" },
          { card2: "Edge AI" },
          { card3: "OPC-UA" },
          { card4: "Linux BSP" },
        ],
      },
    ],
  },
];

const bottomCategories = [
  {
    id: "digital-marketing",
    plainWord: "Our Digital ",
    subword: "Marketing Courses",
    desc: "Learn SEO, Google Ads, social media marketing, content strategy and analytics from industry practitioners. Our Digital Marketing courses are designed for entrepreneurs, career switchers and fresh graduates.",
    courses: [
      {
        id: "dm-1",
        title: "Digital Marketing Power-Up",
        subtitle:
          "Launch your digital marketing career in 30 days. SEO, Google Ads, Meta Ads, Canva, Google My Business live campaigns from Day 1.",
        level: "Beginner",
        duration: "1 Months",
        imgSrc: dm_1,
        alt: "Digital Marketing Fundamentals SEO Google Ads Course Skimitar Hindusthan",
        smallcard: [
          { card1: "SEO" },
          { card2: "Google ADS" },
          { card3: "Meta ADS" },
          { card4: "GMB" },
        ],
      },
      {
        id: "dm-2",
        title: "Advanced Digital Marketing Strategies",
        subtitle:
          "SEO, Meta Ads, WordPress and AI automation build full marketing funnels and manage real client campaigns over 3 months.",
        level: "Advanced",
        duration: "2 Months",
        imgSrc: dm_2,
        alt: "Performance Marketing Meta Ads Growth Hacking Course Skimitar Hindusthan",
        smallcard: [
          { card1: "WordPress" },
          { card2: "AI Tools" },
          { card3: "Email Auto" },
          { card4: "Funnels" },
        ],
      },
      {
        id: "dm-3",
        title: "Digital Marketing Mastery",
        subtitle:
          "AI-powered marketing, automation, GA4, HubSpot, full-funnel strategy and data-driven campaigns. Agency-level skills in 6 months.",
        level: "Expert",
        duration: "6 Months",
        imgSrc: dm_3,
        alt: "Brand Content Strategy Marketing Course Skimitar Hindusthan",
        smallcard: [
          { card1: "AI Marketing" },
          { card2: "GA4" },
          { card3: "HubSpot" },
          { card4: "Automation" },
        ],
      },
    ],
  },
  {
    id: "it-software",
    plainWord: "Our IT & ",
    subword: "Software Development Courses",
    desc: "From full-stack web development and Python programming to AI, data science and cloud computing our IT courses are continuously updated to match current industry hiring standards and employer expectations.",
    courses: [
      {
        id: "it-1",
        title: "Python Full Stack Development",
        subtitle:
          "Django, React, REST APIs and Cloud Deployment build scalable full-stack web applications from backend to browser.",
        level: "Advanced",
        duration: "3 Months",
        imgSrc: it_1,
        alt: "Python Full Stack Development Course Skimitar Hindusthan",
        smallcard: [
          { card1: "Python" },
          { card2: "Django" },
          { card3: "React" },
          { card4: "REST API" },
        ],
      },

      {
        id: "it-2",
        title: "Java Full Stack Development",
        subtitle:
          "Spring Boot, React, REST APIs and Cloud Deployment enterprise-grade full stack for high-demand job markets.",
        level: "Advanced",
        duration: "3 Months",
        imgSrc: it_2,
        alt: "Java Full Stack Development Course Skimitar Hindusthan",
        smallcard: [
          { card1: "JAVA" },
          { card2: "Spring Boot" },
          { card3: "React" },
          { card4: "AWS" },
        ],
      },

      {
        id: "it-3",
        title: "MERN Stack Development",
        subtitle:
          "MongoDB, Express, React and Node.js with Next.js 15 and AI integration build modern full-stack apps deployed to production.",
        level: "Advanced",
        duration: "4 Months",
        imgSrc: it_3,
        alt: "MERN Stack Development Course Skimitar Hindusthan",
        smallcard: [
          { card1: "MONGODB" },
          { card2: "React" },
          { card3: "Node.js" },
          { card4: "Next.js 15" },
        ],
      },

      {
        id: "it-4",
        title: "Mobile App Development",
        subtitle:
          "React Native, Flutter, Firebase and App Store Launch build iOS and Android apps from design to Play Store in one course.",
        level: "Advanced",
        duration: "4 Months",
        imgSrc: it_4,
        alt: "Mobile App Development Course Skimitar Hindusthan",
        smallcard: [
          { card1: "React Native" },
          { card2: "Flutter" },
          { card3: "Firebase" },
          { card4: "App Store" },
        ],
      },

      {
        id: "it-5",
        title: "Data Analytics",
        subtitle:
          "Python, SQL, Power BI, statistical analysis and AI-driven insights transform raw data into business decisions.",
        level: "Advanced",
        duration: "3 Months",
        imgSrc: it_5,
        alt: "Data Analytics Course Skimitar Hindusthan",
        smallcard: [
          { card1: "Python" },
          { card2: "SQL" },
          { card3: "Power BI" },
          { card4: "Statistics" },
        ],
      },

      {
        id: "it-6",
        title: "Data Science & Machine Learning",
        subtitle:
          "Python, Deep Learning, LLMs, RAG systems and MLOps build and deploy AI models for real-world applications.",
        level: "Expert",
        duration: "6 Months",
        imgSrc: it_6,
        alt: "Data Science Machine Learning Course Skimitar Hindusthan",
        smallcard: [
          { card1: "Deep Learning" },
          { card2: "LLMS" },
          { card3: "RAG" },
          { card4: "ML Ops" },
        ],
      },

      {
        id: "it-7",
        title: "UI/UX Design",
        subtitle:
          "Figma, user research, prototyping, design systems and AI-assisted design create products people love to use.",
        level: "Advanced",
        duration: "2 Months",
        imgSrc: it_8,
        alt: "UI UX Design Course Skimitar Hindusthan",
        smallcard: [
          { card1: "Figma" },
          { card2: "Prototyping" },
          { card3: "Design System" },
          { card4: "UX Research" },
        ],
      },

      {
        id: "it-8",
        title: "AWS Cloud",
        subtitle:
          "Solutions architecture, serverless computing, DevOps, AI services and multi-cloud strategy become AWS certified.",
        level: "Expert",
        duration: "2 Months",
        imgSrc: it_9,
        alt: "AWS Cloud Course Skimitar Hindusthan",
        smallcard: [
          { card1: "EC2 & S3" },
          { card2: "Lambda" },
          { card3: "Terraform" },
          { card4: "Multi-Cloud" },
        ],
      },

      {
        id: "it-9",
        title: "DevOps Engineer",
        subtitle:
          "CI/CD, Docker, Kubernetes, Terraform, Ansible and Platform Engineering automate and scale infrastructure like a pro.",
        level: "Expert",
        duration: "3 Months",
        imgSrc: it_7,
        alt: "DevOps Engineer Course Skimitar Hindusthan",
        smallcard: [
          { card1: "Docker" },
          { card2: "Kubernetes" },
          { card3: "Terraform" },
          { card4: "GitOps" },
        ],
      },

      {
        id: "it-10",
        title: "Cybersecurity & Ethical Hacking",
        subtitle:
          "Penetration testing, SOC operations, cloud security and AI threat detection defend systems and think like an attacker.",
        level: "Expert",
        duration: "6 Months",
        imgSrc: it_10,
        alt: "Cybersecurity Ethical Hacking Course Skimitar Hindusthan",
        smallcard: [
          { card1: "Pen Testing" },
          { card2: "Kali Linux" },
          { card3: "SOC" },
          { card4: "AI Threats" },
        ],
      },
    ],
  },
];

/* ══════════════════════════════════════════════════
   HOOKS
══════════════════════════════════════════════════ */

function useScrollReveal(ref) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.opacity = "0";
    el.style.transform = "translateY(44px)";
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.style.transition =
            "opacity 0.75s cubic-bezier(0.25,0.46,0.45,0.94), transform 0.75s cubic-bezier(0.25,0.46,0.45,0.94)";
          el.style.opacity = "1";
          el.style.transform = "translateY(0)";
          observer.disconnect();
        }
      },
      { threshold: 0.1 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
}

function useCardsReveal(sectionRef) {
  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const cards = Array.from(section.querySelectorAll(".oc-reveal"));
    cards.forEach((card, i) => {
      card.style.opacity = "0";
      card.style.transform =
        i % 2 === 0 ? "translateX(-52px)" : "translateX(52px)";
      card.style.transition =
        "opacity 0.7s cubic-bezier(0.25,0.46,0.45,0.94), transform 0.7s cubic-bezier(0.25,0.46,0.45,0.94)";
    });
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          cards.forEach((card, i) => {
            setTimeout(() => {
              card.style.opacity = "1";
              card.style.transform = "translateX(0)";
            }, i * 90);
          });
          observer.disconnect();
        }
      },
      { threshold: 0.08 },
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);
}

/* ══════════════════════════════════════════════════
   SHARED UI
══════════════════════════════════════════════════ */

const LEVEL_COLOR = {
  Beginner: "#1D9E75",
  Intermediate: "#cc8800",
  Advanced: "#f43c3c",
  Professional: " #cc0000",
  Expert: " #cc0000",
};

const totalcourse =
  topCategories.reduce((sum, cat) => sum + cat.courses.length, 0) +
  bottomCategories.reduce((sum, cat) => sum + cat.courses.length, 0);

function SectionHeader({ label, title, subtitle, sub }) {
  return (
    <div className="mb-2">
      <span className="oc-label">{label}</span>
      <h2 className="mt-2 mb-2" style={{ lineHeight: 1.25 }}>
        <span className="oc-title-main">{title}</span>
        {subtitle && <span className="oc-title-sub"> {subtitle}</span>}
      </h2>
      {sub && <p className="oc-sub mt-3 mb-0">{sub}</p>}
    </div>
  );
}

/* ══════════════════════════════════════════════════
   COURSE CARD (shared between grid + slider)
══════════════════════════════════════════════════ */
function CourseCard({ course }) {
  const tags = course.smallcard
    ? course.smallcard.flatMap((obj) => Object.values(obj))
    : [];

  return (
    <div className="card h-100 border-0 shadow-sm rounded-3 overflow-hidden oc-course-card">
      {/* Image */}
      <div className="position-relative">
        <img
          src={course.imgSrc}
          alt={course.alt}
          className="oc-course-img"
          loading="lazy"
        />
        <div className="oc-course-overlay" />
        <span
          className="position-absolute top-0 start-0 m-3 px-3 py-1 rounded-pill text-white fw-bold"
          style={{
            fontSize: "12px",
            backgroundColor: LEVEL_COLOR[course.level],
          }}
        >
          {course.level}
        </span>
      </div>

      {/* Body */}
      <div className="card-body p-4 d-flex flex-column">
        {/* Duration + Mode */}
        <div className="d-flex justify-content-between align-items-center mb-2">
          <p
            className="mb-0 d-flex align-items-center gap-1 text-dark"
            style={{ fontSize: "13px" }}
          >
            <img src={clock_icon} style={{ width: "14px" }} alt="duration" />
            {course.duration}
          </p>
          <p
            className="mb-0 d-flex align-items-center gap-1"
            style={{ fontSize: "10px" }}
          >
            {/* <FaRegCircle style={{ fontSize: '8px', color: '#cc0000' }} /> */}
            Online / Offline
          </p>
        </div>

        {/* Title */}
        <h5 className="fw-bold mt-1 mb-2 oc-course-title">{course.title}</h5>

        {/* Subtitle */}
        <p className="flex-grow-1 oc-course-subtitle">{course.subtitle}</p>

        {/* Tag Pills */}
        {tags.length > 0 && (
          <div className="d-flex flex-wrap gap-2 mb-3">
            {tags.map((tag, idx) => (
              <span
                key={idx}
                className="small-card rounded-2 px-2 py-1"
                style={{
                  border: "1px solid #0b0b0b",
                  background: "transparent",
                }}
              >
                {tag}
              </span>
            ))}
          </div>
        )}

        {/* Buttons */}
        <div className="d-flex gap-2 mt-auto">
            {/* <button
            className="btn oc-btn-syllabus py-2 flex-fill"
            style={{ fontSize: "13px" }}
          >
            Course Syllabus
          </button> */}
          <button
            className="btn oc-btn-course py-2 flex-fill text-white"
            style={{ background: "#cc0000", fontSize: "13px" }}
            
          >
            Enroll Now →
          </button>
        </div>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════════
   MOBILE SLIDER WRAPPER
══════════════════════════════════════════════════ */
function CourseSlider({ courses }) {
  const sliderRef = useRef(null);

  const scroll = (dir) => {
    const el = sliderRef.current;
    if (!el) return;
    const cardWidth =
      el.querySelector(".oc-slide-item")?.offsetWidth + 16 || 300;
    el.scrollBy({
      left: dir === "next" ? cardWidth : -cardWidth,
      behavior: "smooth",
    });
  };

  return (
    <div className="oc-slider-wrapper position-relative">
      {/* Prev Button */}
      <button
        className="oc-slider-btn oc-slider-btn-prev"
        onClick={() => scroll("prev")}
        aria-label="Previous"
      >
        <FiChevronLeft size={20} />
      </button>

      {/* Slider Track */}
      <div className="oc-slider-track" ref={sliderRef}>
        {courses.map((course) => (
          <div key={course.id} className="oc-slide-item">
            <CourseCard course={course} />
          </div>
        ))}
      </div>

      {/* Next Button */}
      <button
        className="oc-slider-btn oc-slider-btn-next"
        onClick={() => scroll("next")}
        aria-label="Next"
      >
        <FiChevronRight size={20} />
      </button>
    </div>
  );
}

/* ══════════════════════════════════════════════════
   COURSE CATEGORY SECTION
   Desktop: Bootstrap row grid
   Mobile (≤800px): horizontal slider
══════════════════════════════════════════════════ */
function CourseCategory({ cat }) {
  const ref = useRef(null);
  useScrollReveal(ref);

  return (
    <section className="py-5 oc-section-course-gap" ref={ref}>
      <div className="container oc-container">
        <SectionHeader
          label="Courses"
          title={cat.plainWord}
          subtitle={cat.subword}
        />

        <p className="content-text mb-3">{cat.desc}</p>

        {/* Desktop Grid hidden on mobile */}
        <div className="row g-4 d-none d-md-flex">
          {cat.courses.map((course) => (
            <div key={course.id} className="col-12 col-md-6 col-lg-4">
              <CourseCard course={course} />
            </div>
          ))}
        </div>

        {/* Mobile Slider shown only on mobile */}
        <div className="d-md-none">
          <CourseSlider courses={cat.courses} />
        </div>
      </div>
    </section>
  );
}

/* ══════════════════════════════════════════════════
   ABOUT SECTION
══════════════════════════════════════════════════ */
function AboutSection() {
  const ref = useRef(null);
  useScrollReveal(ref);
  return (
    <section className="oc-section-gap" ref={ref}>
      <div className="container oc-container">
        <div className="row g-5 align-items-center">
          <div className="col-lg-6">
            <img
              src={require("../../assets/img/Course/Our Course/Pros And Cons of AI In Manufacturing.webp")}
              alt="Industrial Automation Training at Skimitar Hindusthan"
              className="oc-about-img shadow rounded-3"
            />
          </div>
          <div className="col-lg-6">
            <SectionHeader
              label="About Our Training"
              title="One Partner."
              subtitle="Every Skill. Every Stage."
            />
            <p className="content-text">
              <b>Skimitar Hindusthan's</b> Industrial Automation Training
              programs are designed to equip individuals with the technical
              expertise required to thrive in today's rapidly evolving
              automation industry. Our comprehensive curriculum covers
              Programmable Logic Controllers (PLC), SCADA, HMI, industrial
              robotics, process control, and industrial networking.
            </p>
            <p className="content-text">
              Participants gain hands-on experience on real automation systems,
              enabling them to design, implement, troubleshoot, and maintain
              automated solutions across sectors including manufacturing,
              energy, automotive, and logistics.
            </p>
            <p className="content-text">
              Whether you are a fresher beginning your automation career or a
              working professional upgrading your skills, Skimitar Hindusthan
              provides the structured learning, practical exposure, and
              dedicated placement support needed to accelerate your professional
              growth.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ══════════════════════════════════════════════════
   WHY CHOOSE US
══════════════════════════════════════════════════ */
function WhyChooseUs() {
  const sRef = useRef(null);
  useCardsReveal(sRef);
  return (
    <section className="oc-section-gap oc-bg-soft" ref={sRef}>
      <div className="container oc-container py-lg-3">
        <SectionHeader
          label="Why Choose Us "
          title="Why Choose Automation Training"
          subtitle="at Skimitar Hindusthan"
          sub="We combine industry-expert instruction, real equipment labs, and dedicated placement support to deliver a training experience that translates directly into employment."
        />
        <div className="row g-4">
          {whyCards.map((c) => (
            <div key={c.title} className="col-md-6 col-lg-4">
              <div className="card h-100 border-0 shadow-sm rounded-3 bg-white oc-why-card">
                <div className="card-body p-4 text-center">
                  <img
                    src={c.icon}
                    alt={c.title}
                    className="mb-3"
                    style={{
                      width: "48px",
                      height: "48px",
                      objectFit: "contain",
                    }}
                  />
                  <p
                    className="fw-bold text-uppercase mb-2"
                    style={{ fontSize: "13px", letterSpacing: "0.5px" }}
                  >
                    {c.title}
                  </p>
                  <p
                    className="mb-0"
                    style={{ lineHeight: "1.75", fontSize: "14px" }}
                  >
                    {c.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ══════════════════════════════════════════════════
   AUTOMATION JOURNEY
══════════════════════════════════════════════════ */
function AutomationJourney() {
  const sRef = useRef(null);
  useCardsReveal(sRef);
  return (
    <section className="oc-section-gap oc-bg-soft" ref={sRef}>
      <div className="container oc-container py-lg-3">
        <div className="row g-5 align-items-center">
          <div className="col-lg-6 order-2 order-lg-1">
            <SectionHeader
              label="Your Learning Path"
              title="How to Begin Your"
              subtitle="Industrial Automation Career"
            />
            <div className="d-flex flex-column gap-4">
              {journeySteps.map((step, i) => (
                <div key={step.label} className="d-flex gap-3">
                  <div className="oc-journey-icon">
                    <FiChevronRight size={20} />
                  </div>
                  <div>
                    <p className="fw-bold mb-1" style={{ fontSize: "15px" }}>
                      <span style={{ color: "var(--oc-red)" }} className="me-1">
                        0{i + 1}.
                      </span>
                      {step.label}
                    </p>
                    <p
                      className="mb-0"
                      style={{ lineHeight: "1.75", fontSize: "14px" }}
                    >
                      {step.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-lg-6 order-1 order-lg-2">
            <img
              src={require("../../assets/img/Course/Our Course/how to begin 2.webp")}
              alt="How to begin your automation career journey"
              className="oc-about-img shadow rounded-3"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

/* ══════════════════════════════════════════════════
   PARTNER BRANDS
══════════════════════════════════════════════════ */
function PartnerBrands() {
  const ref = useRef(null);
  useScrollReveal(ref);
  return (
    <section className="oc-section-gap" ref={ref}>
      <div className="container oc-container">
        <SectionHeader
          label="Students Placed Companies"
          title="Companies Where Our"
          subtitle="Students Are Placed"
          sub="Our students are placed in leading IT, automation, and engineering companies through industry-focused training and dedicated placement support."
        />
        <div className="container my-5">
          <div className="row justify-content-center g-4">
            {partnerLogos.map((p, idx) => (
              <div
                className={`col-6 col-md-4 col-lg-3 ${idx >= 3 ? "mt-md-4" : ""}`}
                key={idx}
                data-aos="fade-down"
                data-aos-delay={idx * 300}
              >
                <div className="partner-card text-center p-3 h-100">
                  <div className="partner-img-box mb-2">
                    <img
                      src={p.img}
                      alt={p.name}
                      className="img-fluid partner-img"
                    />
                  </div>
                  <p className="partner-name">{p.name}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

/* ══════════════════════════════════════════════════
   FAQ
══════════════════════════════════════════════════ */
function FAQSection() {
  const ref = useRef(null);
  useScrollReveal(ref);
  return (
    <section className="oc-section-gap oc-bg-soft" ref={ref}>
      <div className="container oc-container py-lg-3">
        <SectionHeader
          label="FAQ"
          title="Frequently Asked"
          subtitle="Questions"
          sub="Everything you need to know about our industrial automation training programs, certifications, and placement support."
        />
        <div className="accordion oc-accordion" id="ocFaq">
          {faqItems.map((item, i) => (
            <div
              className="accordion-item border-0 shadow-sm mb-3 rounded-3 overflow-hidden"
              key={i}
            >
              <h2 className="accordion-header">
                <button
                  className={`accordion-button fw-semibold ${i !== 0 ? "collapsed" : ""}`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#ocFaqItem${i}`}
                  style={{ fontSize: "15px" }}
                >
                  {item.q}
                </button>
              </h2>
              <div
                id={`ocFaqItem${i}`}
                className={`accordion-collapse collapse ${i === 0 ? "show" : ""}`}
                data-bs-parent="#ocFaq"
              >
                <div
                  className="accordion-body"
                  style={{ lineHeight: "1.8", color: "#555", fontSize: "15px" }}
                >
                  {item.a}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ══════════════════════════════════════════════════
   CTA SECTION
══════════════════════════════════════════════════ */
function CTASection() {
  const ref = useRef(null);
  useScrollReveal(ref);
  return (
    <section style={{ marginTop: "50px" }}>
      <div className="p-5" style={{ background: "#cc0000" }}>
        <div className="d-flex align-items-center justify-content-center gap-3 mb-3">
          <div className="bg-light" style={{ width: "40px", height: "1px" }} />
          <span
            className="text-uppercase fw-semibold text-white text-opacity-75"
            style={{
              letterSpacing: "2px",
              whiteSpace: "nowrap",
              fontSize: "13px",
            }}
          >
            Start Your Automation Career
          </span>
          <div className="bg-light" style={{ width: "40px", height: "1px" }} />
        </div>
        <div className="row g-4 align-items-center">
          <div className="col-lg-7 text-center text-lg-start">
            <h2 className="fw-bolder text-white text-uppercase mb-3">
              Your Automation Career Starts at <br />
              "Skimitar Hindusthan"
            </h2>
            <p className="content-text text-white">
              Join thousands of students who chose structured automation
              training, built real hands-on skills, and launched successful
              careers with <b>Skimitar Hindusthan's</b> practical,
              industry-aligned programs and dedicated placement support at every
              step.
            </p>
          </div>
          <div className="col-lg-5">
            <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-end">
              <button className="btn oc-btn-white px-4 py-3 fw-bold text-uppercase">
                Explore All Courses →
              </button>
              <a
                href="tel:8428010909"
                className="btn oc-btn-ghost px-4 py-3 fw-bold text-uppercase"
              >
                📞 (+91) 8428010909
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ══════════════════════════════════════════════════
   MAIN COMPONENT
══════════════════════════════════════════════════ */
const OurCourse = () => {
  const heroRef = useRef(null);
  const [meta, setMeta] = useState(null);

  // scroll top
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const fetchData = () => {
    const OurCourseMeta = data[0]?.our_course;
    if (OurCourseMeta) {
      setMeta(OurCourseMeta);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;
    el.querySelectorAll(".oc-fade-up").forEach((node) => {
      node.style.animationPlayState = "running";
    });
  }, []);

  return (
    <div className="oc-page">
      <Helmet>
        <title>{meta ? meta.title : "Our Courses"}</title>
      </Helmet>

      {/* ── HERO ── */}
      <section className="oc-hero" ref={heroRef}>
        <div
          className="oc-hero-bg"
          style={{ backgroundImage: `url(${course_bg})` }}
        />
        <div
          className="container oc-container position-relative py-5"
          style={{ zIndex: 2 }}
        >
          <div className="d-flex justify-content-center mb-3">
            <span
              className="text-white fw-semibold px-4 py-2 rounded-4 oc-fade-up oc-fade-up-1"
              style={{
                background: "var(--oc-red)",
                fontSize: "13px",
                letterSpacing: "2px",
                textTransform: "uppercase",
              }}
            >
              Course Catalogue
            </span>
          </div>
          <h1
            className="text-white text-center fw-bold mb-3"
            style={{
              fontSize: "clamp(1.6rem, 5vw, 2.6rem)",
              lineHeight: "1.2",
              letterSpacing: "-0.02em",
            }}
          >
            Professional Certification Courses
            <br />
            <em style={{ fontStyle: "normal", color: "#cc0000" }}>
              in Technology &amp; Digital Skills
            </em>
          </h1>
          <p className="oc-hero-sub text-center mx-auto text-white oc-fade-up oc-fade-up-3">
            Explore 20+ certification programs with hands-on training and
            placement support.
          </p>
        </div>
      </section>

      <AboutSection />
      <WhyChooseUs />
      {/* Course Page */}
      <section
        className=" container oc-container"
        style={{ marginTop: "50px" }}
      >
        <p
          className=" text-center all-course-title"
          style={{ fontSize: "30px" }}
        >
          Skimitar Hindustan · Course Catalogue
        </p>
        <h2 className="text-center ">All Courses</h2>
        <div className="d-flex justify-content-center gap-3">
          <p>{totalcourse} Courses </p> |<p>4 Domains</p> |<p> Tamil Nadu </p>
        </div>
      </section>
      {topCategories.map((cat) => (
        <CourseCategory key={cat.id} cat={cat} />
      ))}
      {bottomCategories.map((cat) => (
        <CourseCategory key={cat.id} cat={cat} />
      ))}
      <AutomationJourney />
      <PartnerBrands />
      <FAQSection />
      <CTASection />
    </div>
  );
};

export default OurCourse;
